import { PasswordField } from "@aws-amplify/ui-react";
import { createPasswordSchema, formatMultilineErrorMessage } from "../../utils";
import { useForm } from "react-hook-form";
import { ChangePasswordForm, PasswordPolicy } from "../../types";
import { zodResolver } from "@hookform/resolvers/zod";
import UIButton from "../../../_app/components/UIButton";
import AuthFormShell from "./AuthFormShell";

interface CognitoPasswordChangeFormProps {
  heading: string;
  passwordPolicy: PasswordPolicy | undefined;
  onSubmit: (input: ChangePasswordForm) => void;
  error?: string | null;
  onDismissError?: () => void;
  isLoading?: boolean;
}

const CognitoPasswordChangeForm = ({
  heading,
  onSubmit,
  passwordPolicy,
  error,
  onDismissError,
  isLoading,
}: CognitoPasswordChangeFormProps) => {
  const schema = createPasswordSchema(passwordPolicy);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordForm>({
    resolver: zodResolver(schema),
    mode: "all",
  });

  return (
    <AuthFormShell
      heading={heading}
      onSubmit={handleSubmit((data) => onSubmit(data))}
      error={error}
      onDismissError={onDismissError}
      fields={
        <>
          <PasswordField
            label="Password"
            placeholder="Enter your Password"
            autoComplete="new-password"
            {...register("password")}
            hasError={!!errors.password}
            errorMessage={formatMultilineErrorMessage(errors.password?.message)}
          />
          <PasswordField
            label="Confirm Password"
            placeholder="Please confirm your Password"
            autoComplete="new-password"
            {...register("confirmPassword")}
            hasError={!!errors.confirmPassword}
            errorMessage={formatMultilineErrorMessage(errors.confirmPassword?.message)}
          />
        </>
      }
      actions={
        <UIButton type="submit" isLoading={isLoading} disabled={isLoading}>
          Change Password
        </UIButton>
      }
    />
  );
};

export default CognitoPasswordChangeForm;
